import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { Toaster } from "react-hot-toast";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router-dom";
import { FullWidthLoader } from "./components/full-width-loader";
import { KeycloakProvider } from "./components/keycloak-provider";
import { LocaleProvider } from "./components/locale-provider";
import { ThemeCustom } from "./components/theme-custom";
import { WhiteLabelProvider } from "./components/white-label-provider";
import { ConfigProvider, loadConfig } from "./lib/config";
import Entry from "./modules/entry";
import { BootstrapOverrides } from "./styling/bootstrap-overrides";

import messagesEn from "./translations/en.json";
import messagesEs from "./translations/es.json";
import messagesFr from "./translations/fr.json";

const config = loadConfig();

const messages: Record<string, Record<string, string>> = {
  "en-US": messagesEn,
  "es-ES": messagesEs,
  "fr-FR": messagesFr,
};

const queryClient = new QueryClient();

function App() {
  return (
    <>
      <ConfigProvider value={config}>
        <WhiteLabelProvider>
          <ThemeCustom>
            <QueryClientProvider client={queryClient}>
              <BootstrapOverrides />
              <KeycloakProvider LoadingComponent={<FullWidthLoader />}>
                <BrowserRouter basename="/v6/ng">
                  <LocaleProvider>
                    {locale => (
                      <IntlProvider
                        locale={locale}
                        messages={messages[locale] ? messages[locale] : messages["en-US"]}
                        defaultLocale="en-US">
                        {/*This is the entry point for the application after all providers have been configured. */}
                        <Entry />
                        <Toaster position="bottom-center" />
                      </IntlProvider>
                    )}
                  </LocaleProvider>
                </BrowserRouter>
              </KeycloakProvider>
            </QueryClientProvider>
          </ThemeCustom>
        </WhiteLabelProvider>
      </ConfigProvider>
    </>
  );
}
export default App;
